import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=9c4f4096"
import script from "./SectionTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports